<template>
    <modal v-bind:show.sync="show" ref="modal">
        <div slot="header">
            <h3 class="panel-title f-s-5">{{ trans('Add new category') }}</h3>
            <p class="f-s-4 c-muted">{{ trans('Set a name for this category. This can be used to help organize your hubs on your website home page.') }}</p>
        </div>
        <div class="form-group" v-bind:class="{'has-error': errors.has('title')}">
            <label>
                {{ trans('Category Title') }}
                <input class="input__field" type="text" v-model="category.title">
            </label>
        </div>
        <div v-if="errors.has('title')" class="form-help">
            {{ errors.get('title') }}
        </div>
        <div slot="footer">
            <div class="row row-collapse">
                <div class="column">
                    <button type="button" class="btn btn-primary m-r-3" v-on:click="addCategory" v-bind:class="{'btn-loading': loading}">
                        {{ trans('Add Category') }}
                        <div v-if="loading" class="loader">
                            <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                                <svg class="i-stroke-bright" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import Modal from '../modals/Modal.vue';
    import Errors from '../../errors.js';

    export default {
        components: {
            Modal
        },
        data() {
            return {
                category: {
                    title: ''
                },
                show: false,
                loading: false,
                errors: new Errors()
            }
        },
        methods: {
            addCategory() {
                this.loading = true;
                this.$emit('add-category', this.category);
            },
            reset() {
                this.category = {
                    title: ''
                };

                this.loading = false;
                this.errors.clear();
            },
            setErrors(errors) {
                this.loading = false;
                this.errors.record(errors);
            },
        }
    }
</script>